import { Box, Hidden } from "@material-ui/core"
import moment from "moment"
import React, { useEffect, useMemo } from "react"
import { NavLink } from "react-router-dom"
import { ActionCard } from ".."
import { useQueryUserTrainings } from "../../data"
import { useAuth } from "../../services"
import { useTraining } from "../../utils"
import { ColumnBox, RowBox } from "../Boxes"
import { Icon } from "../Icon"
import { LinearProgress } from "../LinearProgress"

const TrainingDashboardModule = ({ classes, cy = "TrainingDashboardModule", onLoaded }) => {
  const { getActiveModuleIndex } = useTraining()
  const {
    principal: { userID: user },
  } = useAuth()
  const { data } = useQueryUserTrainings({
    variables: {
      user,
    },
  })

  const uncompletedItems = useMemo(
    () => data?.userTrainings.filter((userTraining) => !userTraining.status.completedAt),
    [data]
  )

  useEffect(() => {
    if (uncompletedItems) {
      onLoaded && onLoaded(Boolean(uncompletedItems.length))
    }
  }, [onLoaded, uncompletedItems])

  if (!uncompletedItems?.length) {
    return null
  }

  return (
    <>
      {uncompletedItems.map((userTraining) => {
        const { id, name, dueAt, status } = userTraining
        const overdue = dueAt ? moment(dueAt).isBefore(moment()) : false
        const activeModuleIndex = getActiveModuleIndex(userTraining)
        const activeModule = activeModuleIndex > -1 ? status.modules[activeModuleIndex] : null

        return (
          <ActionCard
            cy={cy}
            key={id}
            cardProps={{
              component: NavLink,
              to: { pathname: `/knowledge/training/${id}`, "data-cy": `${cy}-actioncard` },
            }}
            overdue={overdue}
            title={
              <RowBox className={classes.title} alignItems="flex-start">
                <Icon name="training" />
                <ColumnBox ml={1}>
                  <Box mb={0.5}>{name}</Box>
                  <Box className={classes.caption}>
                    {activeModuleIndex + 1} of {status.modules.length}: {activeModule ? activeModule.name : "Complete"}
                  </Box>
                </ColumnBox>
              </RowBox>
            }
            rightChildren={
              <Box
                mr="auto"
                display="flex"
                flexDirection="row"
                alignSelf="center"
                alignItems="center"
                className={classes.rightChildren}
              >
                <Hidden xsDown>
                  <Box className={classes.progress} mr={1}>
                    <LinearProgress value={status.percentComplete} showValue overdue={overdue} />
                  </Box>
                </Hidden>
              </Box>
            }
          >
            <Hidden smUp>
              <LinearProgress value={status.percentComplete} showValue overdue={overdue} />
            </Hidden>
          </ActionCard>
        )
      })}
    </>
  )
}

export { TrainingDashboardModule }
